import type { ReactNode } from "react";
import { Maximize2, Minus, Plus } from "lucide-react";

import { Button } from "@/components/ui/button";
import { ZOOM_STEP } from "@/lib/zoom";

interface ViewerZoomToolbarProps {
  zoom: number;
  fitMode: boolean;
  disabled?: boolean;
  onManualZoom: (next: number) => void;
  onFitToWidth: () => void;
  /** Right-aligned extra content (e.g. a page indicator). */
  children?: ReactNode;
}

export function ViewerZoomToolbar({ zoom, fitMode, disabled = false, onManualZoom, onFitToWidth, children }: ViewerZoomToolbarProps) {
  return (
    <div className="flex items-center gap-2 border-b bg-card px-3 py-2 text-xs text-muted-foreground">
      <Button type="button" variant="ghost" size="icon" className="size-8" disabled={disabled} onClick={() => onManualZoom(zoom - ZOOM_STEP)} aria-label="Zoom out">
        <Minus className="size-4" />
      </Button>
      <span className="w-10 text-center tabular-nums">{Math.round(zoom * 100)}%</span>
      <Button type="button" variant="ghost" size="icon" className="size-8" disabled={disabled} onClick={() => onManualZoom(zoom + ZOOM_STEP)} aria-label="Zoom in">
        <Plus className="size-4" />
      </Button>
      <Button type="button" variant="ghost" size="sm" className="h-8 gap-1.5" disabled={disabled} onClick={onFitToWidth} aria-pressed={fitMode} aria-label="Fit to width">
        <Maximize2 className="size-4" />
        Fit
      </Button>
      {children}
    </div>
  );
}
